exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_holder .model_button_holder {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  padding-top: 20px; }\n\n.modal_holder button {\n  border: 1.2px solid var(--text-light-blue);\n  background-color: #fff;\n  border-radius: 15px !important;\n  width: auto;\n  padding: 6px 14px;\n  font-size: 14px;\n  display: block; }\n  .modal_holder button:hover {\n    color: #fff;\n    background-color: var(--text-light-blue); }\n\n@media screen and (max-width: 375px) {\n  .ReactModal__Content {\n    inset: 40px 40px 40px 10% !important;\n    width: 300px !important; } }\n\n@media screen and (min-width: 376px) and (max-width: 425px) {\n  .ReactModal__Content {\n    inset: 40px 40px 40px 15% !important;\n    width: 300px !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/modal/modal.scss
// module id = 848
// module chunks = 0